module.exports = __webpack_public_path__ + "static/media/header-logo.46f65f31.svg";